import {buryPoint} from '@/Common/plugins/buried-point';

export default {
  timestamp: buryPoint.timestamp.bind(buryPoint),
  switchRemoteTransToggle(onOff) {
    /*开观交换机延长模式*/
    const eventLabel = onOff ? '开启' : '关闭';
    buryPoint.event({
      action: '端口延长模式-使用功能',
      eventCategory: '端口延长模式',
      eventLabel
    });
  }
};
